module.exports = __webpack_public_path__ + "img/1614.a9e082c0.png";